angular.module('am4').directive('verifyPassword', function(UserService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$asyncValidators.verifyPassword = function(modelValue) {
                return UserService.user.then(function(user) {
                    return UserService.login(user.email, modelValue);
                });
            };
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/directives/verifyPassword.js